// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--oaacE{0%{background-position:200% 0}100%{background-position:-200% 0}}.dashboard-header--L3v3C{z-index:7}.dashboard-header--L3v3C .input-container,.dashboard-header--L3v3C .video-search{width:400px !important;max-width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard-header": "dashboard-header--L3v3C",
	"shimmer-loading": "shimmer-loading--oaacE"
};
export default ___CSS_LOADER_EXPORT___;
